import { useEffect, useRef } from 'react';

import { AccessibilityInfo, UIManager, findNodeHandle } from 'react-native';

import { isWeb } from 'utils/environment';

// Manages focus for native accessibility, focusing the first child element when the drawer prompt is open.
// NOTE: This function is only used on native code paths and contains findNodeHandle which doesn't work on web so this disabled on web.
export const useFocusRef = ({ isFocus, announce }: { isFocus: boolean; announce: string }) => {
  const focusRef = useRef(null);

  useEffect(() => {
    if (isFocus && focusRef.current && !isWeb) {
      AccessibilityInfo.announceForAccessibilityWithOptions(announce, { queue: false });
      const nodeHandle = findNodeHandle(focusRef.current);
      if (nodeHandle) {
        return isWeb
          ? UIManager.focus(nodeHandle)
          : AccessibilityInfo.setAccessibilityFocus(nodeHandle);
      }
    }
  }, [announce, isFocus]);

  return { focusRef };
};
